import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useHeaderStore } from '../../contexts';

/**
 * This hook is used to set the header props for the root header.
 * (eg: with 'Issue Management' title)
 *
 * NOTE: This is the first version of the hook.
 * It can be extended to accept the button props and the chip props later.
 * The intention for creating this hook is to avoid the code repetition
 */
export function useRootHeader() {
  const { setHeaderProps } = useHeaderStore();
  const { t } = useTranslation('common');

  useEffect(() => {
    setHeaderProps({
      viewTitle: { title: t('appName') },
    });
  }, [setHeaderProps, t]);
}
